import axios from "axios";

export const saveRsvps = async (rsvps) => { 
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/rsvps`, rsvps, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return response.data;
}